import React from "react";

const DragWrap = ({children}) => {
    return <div className="flex flex-row">{children}</div>;
};


export default DragWrap;
